export const reviews = [
  {
    id: 1,
    title: "Test – GTA 6",
    rating: 19,
    image: "/images/gta600.jpg",
    pros: [
      "Graphismes révolutionnaires",
      "Ville ultra vivante",
      "Gameplay amélioré"
    ],
    cons: [
      "Quelques bugs mineurs",
      "Très gourmand en ressources"
    ],
    verdict:
      "GTA 6 redéfinit le monde ouvert avec une immersion impressionnante et une narration mature."
  },
  {
    id: 2,
    title: "Test – Assassin’s Creed Shadows",
    rating: 17,
    image: "/images/acshadows.jpg",
    pros: [
      "Ambiance féodale immersive",
      "Système de combat amélioré"
    ],
    cons: [
      "IA parfois limitée"
    ],
    verdict:
      "Une évolution solide de la franchise avec un univers captivant."
  },
  {
    id: 3,
    title: "Test – Elden Ring: Shadow of the Erdtree",
    rating: 19,
    image: "/images/eldenring.jpg",
    pros: ["Direction artistique magistrale", "Difficulté gratifiante"],
    cons: ["Exigeant pour les nouveaux joueurs"],
    verdict: "Une extension qui surpasse de nombreux jeux complets par sa richesse."
  }
];